/**
 * Single adapter for the assessment analytics response shape.
 * Handles both legacy plain-array responses and the current wrapped object.
 *
 * Response evolution:
 *   v1.0 (Stage 1): { risks, monteCarlo }
 *   v1.1 (Stage 2): { risks, monteCarlo, exposurePath }
 *   v1.2 (Stage 4): { risks, monteCarlo, trajectory }
 *   v1.3 (Phase 6): { risks, monteCarlo?, exposurePath?, trajectory?, quantificationFactors? }
 *                   — all 7 assessment types now include quantificationFactors (null until Phase 8
 *                     enrichment worker populates FairScenarios for the assessment risks)
 *
 * All consumers must import from here — never inline-destructure the raw response.
 */
export function parseAnalyticsResponse(response) {
  if (!response) {
    return { risks: [], monteCarlo: null, exposurePath: null, trajectory: null, quantificationFactors: null };
  }

  if (Array.isArray(response)) {
    // Legacy shape — endpoint returned a plain array before Stage 1
    return { risks: response, monteCarlo: null, exposurePath: null, trajectory: null, quantificationFactors: null };
  }

  return {
    risks:                 response.risks                 ?? [],
    monteCarlo:            response.monteCarlo            ?? null,
    exposurePath:          response.exposurePath          ?? null,
    trajectory:            response.trajectory            ?? null,
    quantificationFactors: response.quantificationFactors ?? null,
  };
}
